module.exports = new __parcel__URL__("crystalhaste.0bc2bb3c.png").toString();